import './ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <span className="contact-hero-badge">Get In Touch</span>
          <h1 className="contact-hero-title">
            We're Here to <span className="highlight">Help You</span>
          </h1>
          <p className="contact-hero-subtitle">
            Have questions about career guidance, courses, or colleges? Our team is ready to assist you on your educational journey.
          </p>
        </div>
      </section>

      {/* Head Office Section */}
      <section className="section contact-head-office">
        <div className="container">
          <h2 className="section-title-center">Head <span className="highlight">Office</span></h2>
          <div className="head-office-card">
            <div className="office-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </div>
            <div className="office-details">
              <h3>GooCampus Edu Solutions Pvt Ltd</h3>
              <div className="office-info-grid">
                <div className="info-item">
                  <div className="info-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </div>
                  <div className="info-content">
                    <span className="info-label">Address</span>
                    <p>#138/6, Ground Floor, 10th Main Road,<br />
                    6th A Cross, Sadashiv Nagar, RMV Extension,<br />
                    Behind SBI Bank, Bangalore,<br />
                    Karnataka - 560080, India</p>
                  </div>
                </div>
                <div className="info-item">
                  <div className="info-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </div>
                  <div className="info-content">
                    <span className="info-label">Email</span>
                    <a href="mailto:services@goocampus.in">services@goocampus.in</a>
                  </div>
                </div>
                <div className="info-item">
                  <div className="info-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </div>
                  <div className="info-content">
                    <span className="info-label">Phone</span>
                    <a href="tel:080-41743956">080-41743956</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Branch Offices Section */}
      <section className="section contact-branches">
        <div className="container">
          <h2 className="section-title-center">Branch <span className="highlight">Offices</span></h2>
          <p className="section-subtitle">We have presence across India to serve you better</p>

          <div className="branches-grid">
            {/* Baroda Office */}
            <div className="branch-card">
              <div className="branch-header">
                <div className="branch-icon blue">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div className="branch-location">
                  <h3>Baroda</h3>
                  <span>Gujarat</span>
                </div>
              </div>
              <div className="branch-body">
                <p className="branch-contact-name">Mr. Vrajesh Shah</p>
                <p className="branch-address">
                  C/o: Pravar Educational Consultant<br />
                  FF77 INDIABULLS MEGAMALL<br />
                  NR JETALPUR Bridge, JETALPUR<br />
                  Baroda - 390007
                </p>
                <a href="tel:+917201910001" className="branch-phone">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  +91 7201910001
                </a>
              </div>
            </div>

            {/* Trivandrum Office */}
            <div className="branch-card">
              <div className="branch-header">
                <div className="branch-icon teal">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div className="branch-location">
                  <h3>Trivandrum</h3>
                  <span>Kerala</span>
                </div>
              </div>
              <div className="branch-body">
                <p className="branch-contact-name">Mr. Rajesh</p>
                <p className="branch-address">
                  Menamthottam Chambers, First Floor<br />
                  Opp. Pattom Royal Hotel<br />
                  Pattom PO<br />
                  Trivandrum - 695004
                </p>
                <a href="tel:+919895555027" className="branch-phone">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  +91 9895555027
                </a>
              </div>
            </div>

            {/* Mumbai Office */}
            <div className="branch-card">
              <div className="branch-header">
                <div className="branch-icon orange">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div className="branch-location">
                  <h3>Navi Mumbai</h3>
                  <span>Maharashtra</span>
                </div>
              </div>
              <div className="branch-body">
                <p className="branch-contact-name">Dr. Mayank Mishra</p>
                <p className="branch-address">
                  C/O: Paramedical Institute for Education and Research<br />
                  308, Ellora Fiesta, 3rd Floor, Plot no.8, Sector 11<br />
                  Opp. Juinagar Station, Sanpada<br />
                  Navi Mumbai - 400705
                </p>
                <div className="branch-phones">
                  <a href="tel:+918450968123" className="branch-phone">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    +91 8450968123 (Dr. Mayank)
                  </a>
                  <a href="tel:+919987088950" className="branch-phone">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    +91 9987088950 (Ms. Noyonika)
                  </a>
                </div>
              </div>
            </div>

            {/* Alappuzha Office */}
            <div className="branch-card">
              <div className="branch-header">
                <div className="branch-icon green">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div className="branch-location">
                  <h3>Alappuzha</h3>
                  <span>Kerala</span>
                </div>
              </div>
              <div className="branch-body">
                <p className="branch-contact-name">Mr. Shahul Hameed</p>
                <p className="branch-address">
                  Suit no. 3, Lajnath Complex<br />
                  Zackariah Bazar<br />
                  Alappuzha - 688012
                </p>
                <a href="tel:+916282299799" className="branch-phone">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  +91 6282299799
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="contact-cta-section">
        <div className="container">
          <h2>Have Questions About Your <span className="highlight-light">Career Path</span>?</h2>
          <p>Our experienced counselors are here to guide you through every step of your educational journey.</p>
          <div className="contact-cta-buttons">
            <a href="mailto:services@goocampus.in" className="btn btn-white">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              Email Us
            </a>
            <a href="tel:080-41743956" className="btn btn-teal">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              Call Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
